import React from 'react';

/**
 * Placeholder shown in the conversation column when nothing is selected.
 * The reference always renders a main area beside the list, so the shell
 * keeps its three-column rhythm instead of collapsing to two.
 */
const EmptyPane = ({
  title = 'No conversation selected',
  body = 'Pick a chat from the list to start reading, or create a new one.',
}) => (
  <main
    className="conversation-pane is-placeholder"
    style={{ alignItems: 'center', justifyContent: 'center', background: 'var(--bg)' }}
  >
    {/* `syn-stagger` brings the glyph, then the title, then the body — this is
        the first thing on screen on the Messages route, so it is worth the 120ms
        it costs. See config/theme/motion.css. */}
    <div
      className="syn-stagger"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 13,
        textAlign: 'center',
        padding: 32,
        maxWidth: 380,
      }}
    >
      <span
        style={{
          width: 62,
          height: 62,
          borderRadius: 20,
          display: 'grid',
          placeItems: 'center',
          background: 'var(--accent-soft)',
          color: 'var(--accent-strong)',
        }}
      >
        <svg
          width="27"
          height="27"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 9.7 9.7 0 0 1-2.8-.4L4 21l1.5-4.1A8.3 8.3 0 0 1 3 11.5 8.4 8.4 0 0 1 12 3a8.4 8.4 0 0 1 9 8.5z" />
        </svg>
      </span>
      <div
        style={{ fontSize: 17, fontWeight: 800, letterSpacing: '-0.025em', color: 'var(--text)' }}
      >
        {title}
      </div>
      <div style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.65 }}>{body}</div>
    </div>
  </main>
);

export default EmptyPane;
